import { useCallback, useState } from 'react';

import { apiFetch } from '@/lib/api';

/**
 * Uploads the project's prose screenplay.
 *
 * Shared by the Source Material card and the setup checklist so both can offer a
 * real "add script" action. Note this only writes `source_script` and flips
 * `bible_status` to "needs_generation" — the project still can't produce until the
 * bible is generated from it (see `useBibleGeneration`).
 */
export function useScriptUpload(projectId: string | undefined, onUploaded: () => Promise<void> | void) {
  const [uploading, setUploading] = useState(false);

  const upload = useCallback(
    async (file: File) => {
      if (!projectId) return;
      setUploading(true);
      try {
        await apiFetch(`/api/projects/${projectId}/script-file`, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain' },
          body: await file.arrayBuffer(),
        });
        await onUploaded();
      } finally {
        setUploading(false);
      }
    },
    [projectId, onUploaded],
  );

  return { uploading, upload };
}
